import { render, staticRenderFns } from "./EnvelopeStickers.vue?vue&type=template&id=42443bae&scoped=true"
import script from "./EnvelopeStickers.vue?vue&type=script&lang=js"
export * from "./EnvelopeStickers.vue?vue&type=script&lang=js"
import style0 from "./EnvelopeStickers.vue?vue&type=style&index=0&id=42443bae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42443bae",
  null
  
)

export default component.exports